import * as React from "react";
function SvgTrashBubbles(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      ref={svgRef}
      {...props}
    >
      <path
        d="M154.8 104.7a54.36 54.36 0 01-11.6-9.8 42.74 42.74 0 01-4.9-7.1 51.85 51.85 0 0010-30.6C148.4 25.6 119.6 0 84.1 0S19.9 25.6 19.9 57.2s28.8 57.2 64.2 57.2a69.39 69.39 0 0038.2-11.3l.1.1a57 57 0 0011.9 5.8 63.6 63.6 0 0010.6 2.8 48 48 0 007.5.9c1.8.1 3 .1 2.9.1l1.6-7c-.1.1-.8-.2-2.1-1.1z"
        fill="#70c9f6"
      />
      <path
        d="M96.3 1.1a25.12 25.12 0 00-2.7-.4L20.7 66a20.48 20.48 0 00.5 2.4zM107.3 3.9c-.8-.3-1.5-.5-2.3-.8l-81.5 73 .9 2.1zM116.8 8a19.83 19.83 0 01-2-1.1l-87 77.9 1.2 1.8zM66.9 2.1c-1.6.4-3.1.8-4.6 1.3L23.6 38c-.5 1.4-1 2.7-1.5 4.1zM138.4 87.8c.5-.7.9-1.3 1.4-2l-23.2 20.7a53.59 53.59 0 005.7-3.4l.1.1.6.4 16.1-14.4c-.2-.5-.5-.9-.7-1.4zM83.3 0c-1.1 0-2.2 0-3.3.1L20 53.8c-.1 1-.1 2-.1 2.9zM125.1 13.2l-1.8-1.2-89.9 80.5c.5.5.9 1.1 1.4 1.6zM156.2 109l-4.2 3.8h.4c1.2.1 2.1.1 2.6.1l.4-.4zM144.9 96.6c-.5-.5-1-1.1-1.4-1.5l-13.6 12.2 2.1.9zM146.8 69.6c.3-1.2.5-2.3.7-3.5l-53.1 47.6c1.3-.2 2.6-.4 4-.7zM148.3 55.6a24.37 24.37 0 00-.1-2.7l-68.5 61.3c1 .1 2 .1 3 .1zM152.1 102.8a19.23 19.23 0 01-1.7-1.3l-10.3 9.3c.9.2 1.7.4 2.5.6zM146.7 44.4c-.2-.8-.4-1.5-.6-2.3l-78.6 70.3c.8.2 1.7.4 2.6.6zM138.4 26.6a10.92 10.92 0 00-1.3-1.7l-89 79.7a18.58 18.58 0 001.9 1.1zM132.3 19.4l-1.5-1.5L40.3 99a19.23 19.23 0 001.7 1.3zM143.3 34.9a18.65 18.65 0 00-1-2l-85.1 76.2c.7.3 1.5.6 2.2.9z"
        fill="#f6f6f6"
      />
      <path
        d="M196.6 5.6c-21.8 0-39.5 15.8-39.5 35.2a31.62 31.62 0 006.2 18.8 29.72 29.72 0 01-6.9 8.1 27.68 27.68 0 01-4.5 3.1l1 4.3a32.82 32.82 0 006.3-.6 40 40 0 0013.8-5.3l.1-.1a41.69 41.69 0 0023.5 6.9c21.8 0 39.5-15.8 39.5-35.2S218.4 5.6 196.6 5.6z"
        fill="#b4e8f9"
      />
      <path
        d="M211.1 8.1c-.8-.3-1.5-.5-2.3-.8l-49.7 44.5a18.94 18.94 0 00.9 2.1zM228 19.5L171.6 70c.5-.3 1-.6 1.4-.9l.1-.1c.5.3 1.1.7 1.6 1l54.6-48.9a18.26 18.26 0 00-1.3-1.6zM202.5 6l-2.9-.3-42.4 37.9c.1.9.2 1.7.3 2.5zM164.2 20.8L174 12a35.83 35.83 0 00-9.8 8.8zM191.7 5.9a23.18 23.18 0 00-3.8.6l-29.8 26.7c-.3 1.1-.5 2.3-.7 3.4zM151.9 70.8v.1l.4-.3zM233.2 27.5a18.65 18.65 0 00-1-2l-52.6 47c.7.3 1.5.6 2.2.9zM161.7 62.1l56.7-50.8c-.6-.4-1.3-.7-2-1.1l-53.8 48.2a10.54 10.54 0 00.7 1.1 16.37 16.37 0 01-1.6 2.6zM235.9 44.7c.1-1 .2-2 .2-3L197.8 76c1.1 0 2.3-.1 3.4-.2zM229.7 60a36.12 36.12 0 003.5-6l-21.6 19.4a41.18 41.18 0 006.7-3.2zM224.4 15.8c-.5-.5-1.1-.9-1.7-1.4L155.1 75a31.92 31.92 0 003.7-.5zM235.6 35.1a20.48 20.48 0 00-.5-2.4L187.8 75c.9.2 1.8.3 2.7.5z"
        fill="#f6f6f6"
      />
      <path
        d="M213.1 158.7H83.6a4.2 4.2 0 010-8.4h129.6a4.2 4.2 0 11-.1 8.4z"
        fill="#e2af0e"
      />
      <path
        d="M186.5 256h-76.2a5.35 5.35 0 01-5.3-5L93.6 137.5h109.5L191.8 251a5.35 5.35 0 01-5.3 5z"
        fill="#ffcc10"
      />
      <path
        d="M147.6 245.4a4.23 4.23 0 01-4.2-4.2v-86.7a4.2 4.2 0 018.4 0v86.7a4.23 4.23 0 01-4.2 4.2zM171.9 245.4a4.23 4.23 0 01-4.2-4.2v-86.7a4.2 4.2 0 018.4 0v86.7a4.23 4.23 0 01-4.2 4.2zM124.3 245.4a4.23 4.23 0 01-4.2-4.2v-86.7a4.2 4.2 0 018.4 0v86.7a4.23 4.23 0 01-4.2 4.2z"
        fill="#f9e2af"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTrashBubbles);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
